module.exports = __webpack_public_path__ + "static/media/05.ab4c8a5a.jpg";